import { getAuthHeaders } from "./authSession";

export type ShoppingItem = {
  id: string;
  text: string;
  addedAt: number;
};

export type ShoppingListResponse = {
  items: ShoppingItem[];
  fetchedAt: number;
};

/** Fired after this tab changes the list, so other views refresh at once. */
export const SHOPPING_LIST_CHANGED_EVENT = "homehub:shopping-list-changed";

const post = async (payload: object): Promise<ShoppingListResponse> => {
  const res = await fetch(process.env.REACT_APP_API_ENDPOINT!, {
    method: "POST",
    headers: { "content-type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text();
    let message = text || `Request failed (${res.status})`;
    try {
      message = JSON.parse(text).error ?? message;
    } catch {}
    throw new Error(message);
  }

  return (await res.json()) as ShoppingListResponse;
};

const changed = (result: ShoppingListResponse) => {
  window.dispatchEvent(
    new CustomEvent(SHOPPING_LIST_CHANGED_EVENT, { detail: result }),
  );
  return result;
};

export const getShoppingList = () => post({ action: "getShoppingList" });

export const addShoppingItems = async (items: string[]) =>
  changed(await post({ action: "addShoppingItems", items }));

export const removeShoppingItems = async (ids: string[]) =>
  changed(await post({ action: "removeShoppingItems", ids }));

export const clearShoppingList = async () =>
  changed(await post({ action: "removeShoppingItems", all: true }));
